import { render, staticRenderFns } from "./draw-controls.vue?vue&type=template&id=0c35f560&scoped=true"
import script from "./draw-controls.vue?vue&type=script&lang=js"
export * from "./draw-controls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c35f560",
  null
  
)

export default component.exports